// extracted by mini-css-extract-plugin
export default {"stickyheader":"MainHeader_stickyheader__B5M+w","logo_img":"MainHeader_logo_img__bxyyW"};